/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Disable add-to-cart for variants with stock_status = only_pickup
  function initStockStatusCheck() {
    document.querySelectorAll('[id^="stock-status-"]').forEach(stockDataEl => {
      let stockData = {};
      try { stockData = JSON.parse(stockDataEl.textContent); } catch(e) { return; }

      const formId = stockDataEl.id.replace('stock-status-', '');
      const form = document.getElementById(formId);
      if (!form) return;

      const checkVariant = () => {
        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput) return;
        const statuses = stockData[variantInput.value] || [];
        const isOnlyPickup = Array.isArray(statuses)
          ? statuses.includes('only_pickup')
          : false;
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = isOnlyPickup;
          submitBtn.toggleAttribute('aria-disabled', isOnlyPickup);
        }
      };

      form.addEventListener('change', checkVariant);
      checkVariant();
    });
  }

  document.addEventListener('DOMContentLoaded', initStockStatusCheck);

    document.addEventListener('DOMContentLoaded', initStockStatusCheck);

  // Force line-through on only-pickup variant labels
  function applyOnlyPickupStyling() {
    document.querySelectorAll('[id^="stock-status-"]').forEach(stockDataEl => {
      let stockData = {};
      try { stockData = JSON.parse(stockDataEl.textContent); } catch(e) { return; }

      Object.entries(stockData).forEach(([variantId, statuses]) => {
        if (Array.isArray(statuses) && statuses.includes('only_pickup')) {
          const input = document.querySelector(`input[data-option-value-id="${variantId}"]`);
          if (input) {
            const label = input.closest('.radio__button')?.querySelector('.radio__label');
            if (label) {
              label.style.setProperty('text-decoration', 'line-through', 'important');
            }
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', applyOnlyPickupStyling);

  // ^^ Keep your scripts inside this IIFE function call to

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
